import { render, staticRenderFns } from "./consultas-ver.vue?vue&type=template&id=8d4c56aa"
import script from "./consultas-ver.vue?vue&type=script&lang=js"
export * from "./consultas-ver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports